export enum PanelHubEventType {
    FilterChanged = 'FilterChanged',
    SortChanged = 'SortChanged',
    PaginationChanged = 'PaginationChanged',
    SelectAllToggled = 'SelectAllToggled',
    ItemSelectionChanged = 'ItemSelectionChanged',
    ShowAllChanged = 'ShowAllChanged'
}
